export const ClearDimmed = () => (
  <div className="z-10 fixed top-0 left-0 w-full h-full" />
);

export const DarkDimmed = () => (
  <div className="z-10 fixed top-0 left-0 w-full h-full dimmed_40" />
);
